import { MenuItem, Select, Stack } from '@mui/material'
import { AccessTime, Alarm } from '@mui/icons-material'
import InputB from '../../../components/InputB/InputB'
import { DisplayPHPDate } from '../../../services/DateTime'
import { GLItemDTO, GLItemKinds, GLItemStatus } from '../../../DTO/GLItemDTO'
import LogChatResponsibility from './LogChatResponsibility'
import LogChatMsgDateRow from './LogChatMsgDateRow'
import LogChatMsgPersonTags from './LogChatMsgPersonTags'
import LogChatMsgMarketingFields from './LogChatMsgMarketingFields'
import { isMarketing, isRootItem } from './logChatMsgHelpers'

export default function LogChatMsgExpandPanel({
  glitem,
  onSaving,
  onIdle,
  onChanged,
  onSaveContent,
}: {
  glitem: GLItemDTO
  onSaving: () => void
  onIdle: () => void
  onChanged: () => void
  onSaveContent: (val: string) => Promise<void>
}) {
  return (
    <Stack className="LogChatMsg-expand" spacing={2}>
      <InputB
        title="Überschrift"
        placeholder="Überschrift"
        value={glitem.headline}
        className="w100"
        returnVal={async (value: string) => {
          glitem.headline = value
          await glitem.save()
          onChanged()
        }}
      />

      {isMarketing(glitem) && (
        <>
          <InputB
            title="Ziel"
            placeholder="Ziel"
            value={glitem.target}
            className="w100"
            returnVal={async (value: string) => {
              glitem.target = value
              await glitem.save()
              onChanged()
            }}
          />
          <InputB
            title="Nächster Schritt"
            placeholder="Nächster Schritt"
            value={glitem.nextstep}
            className="w100"
            returnVal={async (value: string) => {
              glitem.nextstep = value
              await glitem.save()
              onChanged()
            }}
          />
        </>
      )}

      {isRootItem(glitem) && (
        <Select
          value={glitem.kind}
          onChange={async (e) => {
            onSaving()
            glitem.status = GLItemStatus.generic
            glitem.kind = Number(e.target.value)
            if (glitem.id === -1) {
              setTimeout(() => onIdle(), 500)
            } else {
              await glitem.save()
              onChanged()
              onIdle()
            }
          }}
          label="Art"
          size="small"
          sx={{ maxWidth: 240 }}
        >
          {GLItemKinds.map(k => {
            if (glitem.showKindOption(k.id) === false) {
              return null
            }
            return (
              <MenuItem value={`${k.id}`} key={`message-${glitem.id}-kindId-${k.id}`}>
                {k.name}
              </MenuItem>
            )
          })}
        </Select>
      )}

      <LogChatResponsibility glitem={glitem} />

      <LogChatMsgDateRow
        icon={<AccessTime />}
        value={glitem.manualdate || ''}
        type="datetime"
        onChange={async (value: string) => {
          await glitem.saveManualDate(value)
          onChanged()
        }}
        onClear={async () => {
          onSaving()
          await glitem.saveManualDate('')
          onChanged()
          onIdle()
        }}
      />

      <LogChatMsgDateRow
        icon={
          <Alarm color={glitem.reminderExpired() ? 'error' : 'inherit'} />
        }
        value={DisplayPHPDate(new Date(glitem.reminderDate || ''))}
        type="date"
        onChange={async (value: string) => {
          await glitem.saveReminderDate(value)
          onChanged()
        }}
        onClear={async () => {
          onSaving()
          await glitem.saveReminderDate('')
          onChanged()
          onIdle()
        }}
      />

      <LogChatMsgPersonTags glitem={glitem} />

      {isMarketing(glitem) && (
        <LogChatMsgMarketingFields
          glitem={glitem}
          onSaving={onSaving}
          onIdle={onIdle}
          onChanged={onChanged}
        />
      )}

      <InputB
        returnVal={onSaveContent}
        type="wysiwyg"
        value={glitem.content}
      />
    </Stack>
  )
}
